var _rect, _polygon, _rect2, _rect3, _rect4, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildbrightLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 80",
    width: 320,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 80,
    fill: "#000000"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "28,38 44,22 60,38",
    fill: "#f97316"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 38,
    width: 24,
    height: 18,
    fill: "#f97316",
    opacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 44,
    width: 10,
    height: 12,
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 24,
    width: 6,
    height: 10,
    fill: "#f97316"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 50,
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
    fontWeight: 800,
    fontSize: 26,
    fill: "#ffffff",
    letterSpacing: -0.5
  }, "Build", /*#__PURE__*/React.createElement("tspan", {
    fill: "#f97316"
  }, "Bright"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 77,
    y: 63,
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
    fontWeight: 400,
    fontSize: 10,
    fill: "#71717a",
    letterSpacing: 2
  }, "NATIONWIDE HOME SERVICES")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildbrightLogo);
export default __webpack_public_path__ + "static/media/buildbright-logo.9b989e8f606b7dfd5dac193ec8870f38.svg";
export { ForwardRef as ReactComponent };